<template>
 <div id="app" class="apps">
        <router-view></router-view>
    </div>
</template>

<script>
// import { utils } from 'src/utils';
export default {
  name: 'App'
}
</script>

<style>
body{
  margin: 0;
  padding: 0;
  font-size: 16px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue